import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import MinPlanPrice from "../../Components/MinPlanPrice";
import CouponScrollBar from "../../Components/CouponScrollBar";
import LinuxCloudVPSVideo from "../../Components/LinuxCloudVPSVideo";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ScrollToPlans } from "../../utils/ScrollToPlan";

export default function LinuxCloudVPS() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
   document.title = "Linux Cloud VPS | Secure & Reliable Hosting"; 
    sal();
  }, []);
  const handlePlanClick = () => {
      ScrollToPlans(".price-plan-section");
      };
  return (
    <>
    <Helmet>
        <title>Linux Cloud VPS | Secure & Reliable Hosting</title>
        <meta name="description" content="Get powerful Linux Cloud VPS hosting with SSD storage, scalable resources, high bandwidth, and managed support. Ideal for apps and businesses." />
        <meta name="keywords" content="Cloud VPS Linux, Cloudlinux Pricing, Linux Cloud VPS Hosting, Linux Cloud VPS " />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/linux-cloud-vps`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/linux-cloud-vps`} />
        <meta property="og:title" content="Powerful Linux Cloud VPS Hosting for Every Varying Demands" />
        <meta property="og:description" content="Check out our Linux Cloud VPS plans, built for exceptional performance. Best for every business, get high uptime & flexible resources to elevate your presence." />
    </Helmet>
      <section className="banner banner-security bg-dark control-panel-banner tilt-banner-part left-to-right-tilt-banner special-tilt-pb">
          <div className="container">
              <div className="row align-items-center">
                  <div className="col-lg-7 col-xl-6">
                      <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          Fast. Flexible. Linux Cloud VPS.
                      </span>
                      <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          Linux Cloud VPS That’s Always Active
                      </h1>
                      <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          Are you experiencing challenges with unexpected downtime affecting your business? With the help of our Linux Cloud VPS, you get continuous performance, keeping your site quick, secure, and always active-just the way it should be.
                      </p>
                      <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                            <span className="btn-arrow__text">
                                Get Started
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                           </button>
                          <MinPlanPrice category="linux-cloud-vps" />
                      </div>
                      <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                  </div>
                  <div className="col-lg-5 col-xl-6 text-lg-end ipad-mt">
                      <img src="images/linux-cloud-vps.webp" alt="image" className="img-fluid full-width-img sal-animate" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" />
                  </div>
              </div>
          </div>
      </section>
      <section className="domain-container special-domain-container position-relative z-1 overflow-hidden pb-60">
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-10">
                          <div className="card cta-wrapper-one rounded-4 domain-container-inner">
                              <div className="card-body pt-60 pb-60">
                                  <div className="row justify-content-center">
                                    <div className="col-md-11 col-lg-10 col-xl-10">
                                        <div className="text-center">
                                          <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Slow? Not With Us.</span>
                                            <h4 className="mb-4">
                                                Too Far = Too Slow. It’s the Right Time to Get Closer.
                                            </h4>
                                            <p className="mb-6">
                                              Ughhh… are you dealing with long-distance issues with your server? That’s the reason for the unexpected lag. Choose a specific server location close to you for high speed, seamless vibes, and no wait time.Once it actually hits, you’ll never go back.
                                            </p>
                                            <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                                <span className="d-inline-block me-1 flex-shrink-0">
                                                    <i className="las la-comments"></i>
                                                </span>
                                                <span className="btn-arrow__text">
                                                    +91-7737300013
                                                    <span className="btn-arrow__icon">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                </span>
                                            </Link>
                                            <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                                <span className="d-inline-block me-1 flex-shrink-0">
                                                    <i className="las la-comments"></i>
                                                </span>
                                                <span className="btn-arrow__text">
                                                    Talk to an Expert
                                                    <span className="btn-arrow__icon">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
      </section>
      <section className="pt-40 pb-100">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center gap-row">
                    <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                      <div className="card">
                          <div className="card-body">
                            <div className="features-video position-relative z-1"><img alt="image" className="img-fluid w-100" src="/images/linux-cloud-vps-thumbnail-yt.webp" /><Link to="#" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init" data-bs-toggle="modal" data-bs-target="#linuxCloudVpsModal"><i className="fa-solid fa-play"></i></Link></div>
                          </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="ps-xl-2">
                            <span className="d-block text-primary fs-18 fw-bold mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Why Linux Cloud VPS?
                            </span>
                            <h2 className="mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Why Businesses Go For Our Linux Cloud VPS
                            </h2>
                            <div className="w-12 h-1 bg-primary mb-6 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine"></div>
                            <p className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Worried about slow websites and server interruption? Infinitive Host always gives you stress-free Linux Cloud VPS solutions- quick, scalable, and engineered to keep your sites and applications always on the right point.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
          <div className="row g-4">
              <div className="col-sm-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card h-100">
                      <div className="card-body p-xl-8">
                          <div className="hstack gap-3 mb-4">
                              <span className="d-inline-block flex-shrink-0">
                                  <img src="images/around-the.webp" alt="image" className="img-fluid" />
                              </span>
                              <h6 className="mb-0 flex-grow-1">
                                  Around the Clock Support
                              </h6>
                          </div>
                          <p className="mb-0">
                              Got any questions or facing a significant issue? Our expert team is just a click away. Whether it’s early in the morning or late at night, we’re here to keep your Linux Cloud VPS running.
                          </p>
                      </div>
                  </div>
              </div>
              <div className="col-sm-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card h-100">
                      <div className="card-body p-xl-8">
                          <div className="hstack gap-3 mb-4">
                              <span className="d-inline-block flex-shrink-0">
                                  <img src="images/exceptional-global.webp" alt="image" className="img-fluid" />
                              </span>
                              <h6 className="mb-0 flex-grow-1">
                                  Exceptional Global Reach
                              </h6>
                          </div>
                          <p className="mb-0">
                              Our KVM-based cloud VPS servers help you count on high performance no matter where you are. Our global data centers guarantee quick hosting that meets your demands.
                          </p>
                      </div>
                  </div>
              </div>
              <div className="col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card h-100">
                      <div className="card-body p-xl-8">
                          <div className="hstack gap-3 mb-4">
                              <span className="d-inline-block flex-shrink-0">
                                  <img src="images/value-packed.webp" alt="image" className="img-fluid" />
                              </span>
                              <h6 className="mb-0 flex-grow-1">
                                  Value-Packed VPS Hosting
                              </h6>
                          </div>
                          <p className="mb-0">
                              Get scalable Linux VPS server hosting without simply compromising on both speed and performance. We bring you the perfect value, supporting your business success.
                          </p>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </section>
      <section className="price-plan-section pt-100 pb-100 position-relative">
        <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
        <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-8">
                          <div className="text-center">
                              <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                              <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Our Hosting. Your Growth.</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        <PlanList category={'linux-cloud-vps'}/>
      </section>
      <section className="pt-100">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8 col-lg-9">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Pure Linux, Real Performance.
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Your Digital Home, Powered by Linux VPS Hosting</h2>
                        <p className="text-dark mb-0 max-text-56 mx-auto sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Our system monitors network traffic and
                            routes malicious activity to our
                            attack mitigation farm as soon as a DDoS event is detected.</p>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 h-100 p-xl-10 rounded-3">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Superfast SSD Power</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/wish-for-dedicated.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Experience high-speed site loading along with SSD-powered Linux VPS Servers - because your site visitors won’t have to wait, and neither should you.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 h-100 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Host Sites Without Limits</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/sites-that-never.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Launch multiple sites as your business demand increases-no more hidden charges, no stress. One account, limitless possibilities.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 h-100 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Instant Server Launch</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/unexpected-server.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Why do you have to wait? Get your Linux Cloud VPS always up and running on time after order verification. Fast. Secure. Ready to roll.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 h-100 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Pick Your Ideal OS & Control Panel</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/control-like.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Select from a variety of operating systems available and handle your server with a user-friendly control panel. It’s very simple, visual, and engineered for clarity.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 h-100 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Full Access with SSH (Secure Shell)</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/full-access-with.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Do you love Linux? Get full admin access with highly protected SSH access. It’s all about your server, your rules-with zero barriers.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 h-100 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Free Setup, Easy Migration</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/free-setup.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Starting new or shifting from one host to another? We have got you covered with our free setup and migration process - no hassle, no headache.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 h-100 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Scale as You Grow</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">07</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/scale-as-you.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Need more demanded power? Simply upgrade storage, bandwidth, or RAM with a single click. Grow at your desired speed, not your service provider’s.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 h-100 rounded-3 p-xl-10">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Worry-Free Backups</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">08</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/worry-free.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Tired of data loss? Not to worry on our watch. Every Linux Cloud VPS solution has automatic backups to always keep your data secure.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <div className="pb-60 pt-100">
        <div className="container">
            <div className="row g-4 align-items-center">
                <div className="col-md-6">
                    <div className="ps-lg-8 pe-xxl-12">
                        <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            Linux Power, Cloud Freedom.
                        </span>
                        <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            Linux Cloud Server Hosting: Host Your Way, Every Day
                        </h3>
                        <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                            Feeling trapped by sluggish servers and limited resources? With our Linux Cloud VPS solutions, every byte functions intelligently. Say bye-bye to unexpected downtime and say hi to seamless sailing.
                        </p>
                        <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height">
                            <span className="btn-arrow__text">
                                Get Started Now
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </button>
                    </div>
                </div>
                <div className="col-md-6 sal-animate mobile-mt" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <img src="images/linux-cloud-server.webp" alt="image" className="img-fluid" />
                </div>
            </div>
        </div>
      </div>
      <section className="pt-40 pb-100">
        <div className="container">
            <div className="cta-wrapper-one pt-60 pb-60 px-6 rounded-3">
                <div className="row justify-content-center">
                    <div className="col-xxl-7 col-xl-9">
                        <div className="d-flex justify-content-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <div className="px-3 py-1 border border-primary rounded d-inline-flex align-items-center gap-2">
                                <div className="w-2 h-2 rounded-circle bg-primary"></div>
                                <small className="text-primary fw-bold">Built for Builders</small>
                            </div>
                        </div>
                        <div className="text-center mt-5">
                            <h2 className="mb-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Step Into the Digital World</h2>
                            <p className="mb-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">No worries! Contact us for expert guidance and instant setup, and see how our Linux cloud server hosting can revolutionize your business.</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap flex-md-nowrap sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                            <span className="btn-arrow__text">
                                Get Started
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                           </button>
                            <Link to="/frequently-asked-questions" className="btn btn-dark btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Learn More
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <LinuxCloudVPSVideo />
    </>
  );
}
